export type FormTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  select: {
    createItem: string;
    loading: string;
    noOptionsMessage: string;
    typeToSearch: string;
  };
};

export const formTranslation: FormTranslation = {
  button: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  select: {
    createItem: "Utwórz '{{item}}'",
    loading: 'Ładowanie...',
    noOptionsMessage: 'Brak opcji',
    typeToSearch: 'Rozpocznij pisanie, aby wyszukać',
  },
};
